export function push_form_field(fields, name, start_index = 1) {
  fields[name] = start_index + Object.keys(fields).length
}
